import { useState, useContext } from "react";

import { Button, Alert } from "flowbite-react";

import { Actions } from "../reducers/Booking";

import rtc from "../services/rtc";
import {
  FaCalendarAlt,
  FaCar,
  FaMapMarkerAlt,
  FaRegUserCircle,
  FaTools,
} from "react-icons/fa";

import { MONTHS, APPOINTMENT_TYPE } from "../constants";
import AppContext from "../context/AppContext";

const padLeft = (v, l, ch) => {
  const str = "" + v;
  if (str.length >= l) {
    return v;
  }
  return new Array(l - str.length).fill(ch).join() + str;
};

const Page = ({ state, dispatch, onError }) => {
  const {
    brand: {
      buttonPrimaryBorderColor,
      buttonPrimaryBackgroundColor,
      buttonPrimaryTextColor,
    },
  } = useContext(AppContext);

  const [error, setError] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    setError(null);

    const appDateTime = state.availability.date
      ? [
          state.availability.date.getFullYear(),
          padLeft(state.availability.date.getMonth() + 1, 2, "0"),
          padLeft(state.availability.date.getDate(), 2, "0"),
        ].join("-") + `T${state.availability.time}:00`
      : "";

    const booking = {
      appointmentTime: appDateTime,
      courtesyLift: state.availability.value === "lift",
      courtesyVehicle: state.availability.value === "car",
      courtesyVehicleCharge: 0.0,
      courtesyVehicleSelfInsure: false,
      customSlot: false,
      mot: false,
      whileYouWait: state.availability.value === "wait",
      customer: state.customer,
      vehicle: state.vehicle,
      repairOperations: state.repairOperations,
      colDelDetails: [],
      sendEmailToCustomer: false,
    };

    rtc
      .createBooking(state.dealer.dealerId, booking)
      .then(() => {
        dispatch({
          type: Actions.Confirm,
          payload: { feasaServicePlan: false, feasaQuote: false },
        });
      })
      .catch((err) => {
        const { message } = err;

        console.error(message);

        onError({
          error: true,
          field: "",
          type: "RTC",
          message: message,
        });

        setError(message || err);
      });
  };

  return (
    <>
      <h2 className="text-4xl font-bold text-center">Your booking</h2>
      <p className="font-bold text-center">
        Please check your booking information is correct
      </p>
      <div className="grid grid-cols-2 gap-x-16 gap-y-4 mt-4">
        <div>
          <FaCar size="2em" />
          <h3 className="text-2xl font-bold pb-4">Your Vehicle</h3>
        </div>
        <div>
          <p className=" text-xl text-slate-500">{state.vehicle.regnum}</p>
          <p className="text-xl text-slate-500">{state.vehicle.description}</p>
        </div>

        <div>
          <FaMapMarkerAlt size="2em" />
          <h3 className="text-2xl font-bold pb-4">Selected Location</h3>
        </div>
        <div>
          <p className="text-xl text-slate-500">{state.dealer.description}</p>
        </div>

        <div>
          <FaTools size="2em" />
          <h3 className="text-2xl font-bold pb-4">Your Service</h3>
        </div>
        <div>
          {state.repairOperations.map((ro) => (
            <p className="text-xl text-slate-500" key={ro.code}>
              {ro.description}
            </p>
          ))}
        </div>

        <div>
          <FaCalendarAlt size="2em" />
          <h3 className="text-2xl font-bold pb-4">Your Appointment</h3>
        </div>
        <div>
          <p className="text-xl text-slate-500">
            {APPOINTMENT_TYPE[state.availability.value]}
          </p>
          {state.availability.date && (
            <p className="text-xl text-slate-500">
              {MONTHS[state.availability.date.getMonth()]}{" "}
              {state.availability.date.getDate()},{" "}
              {state.availability.date.getFullYear()} at{" "}
              {state.availability.time}
            </p>
          )}
        </div>

        <div>
          <FaRegUserCircle size="2em" />
          <h3 className="text-2xl font-bold pb-4">Your Details</h3>
        </div>
        <div>
          <p className="text-xl text-slate-500">
            {state.customer.forename} {state.customer.surname}
          </p>
          <p className="text-xl text-slate-500">{state.customer.email}</p>
          <p className="text-xl text-slate-500">{state.customer.phone1}</p>
          <p className="text-xl text-slate-500">{state.customer.phone2}</p>
          <p className="text-xl text-slate-500">
            {state.customer.address1} {state.customer.address2}{" "}
            {state.customer.address3} {state.customer.address4}
          </p>
        </div>
      </div>
      {error && (
        <Alert color="failure">
          There was an error during creation of the booking. Please try again
          later {error ? `(${error})` : null}
        </Alert>
      )}
      <div className="mt-8">
        <Button
          type="button"
          color="dark"
          className="w-full md:w-3/4 md:m-auto"
          style={{
            borderColor: buttonPrimaryBorderColor,
            backgroundColor: buttonPrimaryBackgroundColor,
            color: buttonPrimaryTextColor,
          }}
          onClick={handleSubmit}
        >
          Continue
        </Button>
      </div>
    </>
  );
};

const Description = ({ state }) => <></>;

const tuple = { Page, Description };

export default tuple;
